<template>
  <div class="category-chart-wrapper">
    <!-- 总销售额 -->
    <div class="total-amount">
      总销售额：<span class="amount">{{ totalAmount | formatMoney }} 元</span>
    </div>

    <!-- 空数据提示 -->
    <div v-if="!categoryData.length" class="empty-tip">
      暂无数据可展示
    </div>

    <!-- 图表容器 -->
    <div
        v-else
        ref="categoryChart"
        style="height: 350px;"
    ></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    categoryData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      totalAmount: 0
    }
  },
  watch: {
    categoryData: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.updateChart()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    initChart() {
      if (this.$refs.categoryChart) {
        this.chart = echarts.init(this.$refs.categoryChart)
        this.updateChart()
      }
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    updateChart() {
      if (!this.chart) {
        this.initChart()
        if (!this.chart) return
      }

      if (!this.categoryData.length) {
        this.chart.clear()
        this.totalAmount = 0
        return
      }

      const total = this.categoryData.reduce((sum, item) => sum + item.value, 0)
      this.totalAmount = total

      const displayData = this.categoryData.map(item => {
        const percent = total === 0 ? 0 : (item.value / total * 100).toFixed(2)
        return {
          name: item.name,
          value: item.value,
          percent: percent
        }
      })

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: params => {
            return `${params.name}<br/>销售额: ${params.value.toLocaleString()} 元<br/>占比: ${params.percent}%`
          }
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center'
        },
        series: [
          {
            name: '销售占比',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold',
                formatter: '{b}\n{d}%'
              }
            },
            labelLine: {
              show: false
            },
            data: displayData
          }
        ]
      }

      this.chart.setOption(option)
    }
  },
  filters: {
    formatMoney(val) {
      if (!val) return '0.00'
      return Number(val).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.category-chart-wrapper {
  padding: 10px;
  position: relative;
}

.total-amount {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
}

.amount {
  color: #409EFF;
}

.empty-tip {
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  font-size: 16px;
  background-color: #f5f7fa;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// CategoryPie.vue?5549e8fa